import src from "IMAGE";
export default { src, width: 1245, height: 119, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ANPqvv/j8tn/1OLv/+Hk7v/z1sv/9tvU//XR1v/11tv/24Yc9Scu5XEAAAAASUVORK5CYII="};
